module.exports = __webpack_public_path__ + "static/media/Manrope.980b9f32.ttf";